import axios from 'axios/index'
import storage from './storage'

export default {
	toPictureUrl(value, pre) {
		if (!value) {
			return "";
		}
		if (value.indexOf("http") === 0) {
			return value;
		}
		if (!pre) {
			pre = 'https://photo.youkeya.cn/'
		}
		return pre + value;
	},
	uuid(){
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){
			var r = Math.random() * 16 | 0,
				v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		})
	},
	getUploadImgToken(){
		console.log("getUploadImgToken from api")
		
		// 获取上传图片的token保存到本地
		axios.get("/basic/qiniu/image/token").then(function(res) {
			if (res && res.data && res.data["code"] === 200 && res.data["data"]) {
				
				console.log("geted token:",res.data);
				
				let qiniuToken = res.data["data"]["uploadToken"];
			
				storage.setUploadImgToken(qiniuToken);
			
				return
			}else{
				console.log("获取上传图片凭证失败");
			}
			
		});
	},
	getCurrentShopId(){
		const shop = storage.getCurrentShop();
		if(shop){
			return shop.id;
		}else{
			return "";
		}
	},
    getNowDate(){
	  var timestamp = Date.parse(new Date());
	  var date = new Date(timestamp);
	  //获取年份  
	  var Y =date.getFullYear();
	  //获取月份  
	  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
	  //获取当日日期 
	  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(); 
	 
	  return Y+'-'+M+'-'+D;
	},
	throttle (func, wait) {
	  let timeout = null
	  return function () {
	      const context = this
	      const args = arguments
	      if (!timeout) {
	          timeout = setTimeout(() => {
	              timeout = null
	              func.apply(context, args)
	          }, wait)
	      }
	  }
	},
	isDecimal(num){
		// 包括0 带2位小数
		//var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
		var reg = /^([1-9]\d{0,9}|0)(\.\d{1,2})?$/;
		if (reg.test(num)) {
		    return true;
		}
		return false;
	},
	isInt(num){
		// 含0 正整数
		var reg = /^([1-9]\d*|[0]{1,1})$/;
		if (reg.test(num)) {
			return true;
		}
		return false;
	},
	cancelAndFetch(){
		
		let controller;
		let signal;
		
		return function(url){
			if (controller){
				controller.abort()
			}
			controller= new AbortController()
			signal = controller.signal
			
			return axios.get(url,{signal})
		}
	},
	getFirstDayOfMonth() {
	    const now = new Date();
	    const year = now.getFullYear();
	    const month = String(now.getMonth() + 1).padStart(2, '0');
	    return `${year}-${month}-01`;
	},
	getLastDayOfMonth() {
	    const now = new Date();
		const year = now.getFullYear();
		const month = now.getMonth() + 1;
		// 创建一个新的日期对象，设置为下个月第0天，就是本月最后一天啦
		const lastDay = new Date(year, month, 0);
		const lastMonth = String(lastDay.getMonth() + 1).padStart(2, '0');
		const lastDate = String(lastDay.getDate()).padStart(2, '0');
		return `${year}-${lastMonth}-${lastDate}`;
	},
	diffDate(startDateStr, endDateStr) {
	    const startDate = new Date(startDateStr);
	    const endDate = new Date(endDateStr);
	    const timeDiff = endDate.getTime() - startDate.getTime();
	    const dayDiff = timeDiff / (1000 * 3600 * 24);
	    return dayDiff;
	}
}
